import { inject, Injectable } from "@angular/core";
import { SERVICE_STORE } from "../../domain/tokens/service-store.token";
import { Drawer } from "@features/service/domain/models/drawer.model";
import { EVENT_BUS } from "@shared/domain/tokens/event-bus.token";
import { ServiceSelectionChangedEvent } from "@platform/event-bus/domain/events/service-selection-change.event";

@Injectable({ providedIn: 'root' })
export class SelectCashDrawerUseCase {
  private readonly serviceStore = inject(SERVICE_STORE);
  private readonly eventBus = inject(EVENT_BUS);

  execute(drawer: Drawer): void {
    this.serviceStore.setSelection({ drawer });

    const { selection } = this.serviceStore.state();

    this.eventBus.publish(new ServiceSelectionChangedEvent(selection));
  }
}